import './index.scss'

const About = () => {
    return(
        <>
        Hello
        </>
    )
}

export default About